
import { Vue, Component, Prop } from 'vue-property-decorator';
import Profile from '@/components/ProfileView.vue';
import RatingComponent from '@/components/RatingComponent.vue';
import DialogUploadFileComponent from '@/components/DialogUploadFileComponent.vue';

@Component({
  components: {
    Profile,
    RatingComponent,
    DialogUploadFileComponent,
  },
})
export default class PopupEventItem extends Vue {
  @Prop({ default: '' }) readonly propTitle: string;

  dialog = false;

  async show(show: boolean = true) {
    this.dialog = show;
  }
}
